import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useOrganizationId } from '@app/utils/hooks';
import { type ProductPageTab, productTabPath } from '@app/constants/url';
import type { ScrollTarget } from '@app/components/core/arrivalScroll';
import CardArrow from '../../clientReporting/product/CardArrow';
import { useProductViewer } from './productViewer';

/** A card's arrow into another tab of this product, at the address the viewer reads it under. */
const TabArrow = ({
  tab,
  scrollTo,
  view,
}: {
  tab: ProductPageTab;
  /** Which reading of the tab to open on, where it has more than one. */
  view?: string;
  /** The part of the tab to glide to on arrival: an element's id. */
  scrollTo: ScrollTarget;
}): JSX.Element => {
  const { t } = useTranslation();
  const organizationId = useOrganizationId();
  const { productId = '' } = useParams<{ productId: string }>();
  const { isClient } = useProductViewer();
  return (
    <CardArrow
      to={`${productTabPath(organizationId ?? '', productId, tab, isClient)}${view ? `?view=${view}` : ''}`}
      label={t('productDashboard.openTab', { tab: t(`tabs.${tab}`) })}
      state={{ scrollTo }}
    />
  );
};

export default TabArrow;
